import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { CommonService } from '../services/common.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Subject } from 'rxjs/internal/Subject';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import * as $ from 'jquery';
import { state } from '@angular/animations';
declare var $: any;

@Component({
  selector: 'app-intimate',
  templateUrl: './intimate.component.html',
  styleUrls: ['./intimate.component.css'],
  providers: [CommonService]
})
export class IntimateComponent implements OnInit {
  intimate: any = {};
  intimateSuccessfull: boolean = false;
  hospitalNameField: boolean = true;
  hospitalListField: boolean = false;
  paramountHospitalListField: boolean = false;
  loading: boolean;
  error: string;
  cardNumber: string;
  claimantName: any = [];
  email: string;
  mobile: string;
  policyNumber: any = [];
  insurer: any = [];
  tpaCode: string;
  tpaId: string;
  tpaName: string;
  hospitalList: any = [];
  paramountHospitalList: any = [];
  individualInsuranceClaimant: boolean;
  contactNo: string;
  noDataFound: boolean = false;
  data: any;
  policy: any;
  regDate: any;
  dischargeDate: any;
  contactNumber: string;
  selectedClaimantName: any = "";
  sendClaimantName: any = '';
  productType:any='';
  selectedPolicyNumber: any = "";
  intimateFailure: boolean = false;
  selectedInsurerName: string = "";
  selectedRelation: string = "";
  selectedPaymentMode: string = "";
  policiesArrayData: any;
  DOBrequired: boolean;
  mobileNumber: string;
  estimatedAmount: string;
  adminssionMaxDate: Date;
  errorMessage: string;
  AddmissionDateRequired: boolean;
  dischargeDateRequired: boolean;
  relationLists: any = [];
  hospitalState: string;
  hospitalCity: string;
  hospitalName: string;
  hospitalAddress: string;
  hospitalPincode: string;
  companyName: string;
  employeeName: string;
  employeeId: string;
  dob: Date;
  ailment: string;
  babyName:string;
  babyDob:Date;
  babyGender:string;
  employeeCode:string;
  private onDestroy$: Subject<void> = new Subject<void>();
  diseaseList: any = ["Accelerated Hypertention", "ACL tear", "Acute Gastro entritis", "Anal Fissure",
    "Appendix", "Bronchitis", "CA Breast", "Carcinoma of any part", "Cataract", "Cerebrovascular attack", "CHOLELITHIASIS", "Chronic Kidney Disease", "Coronary Artery Disease", "CSOM", "COVID-19",
    "Dengue", "Deviated Nasal Septum", "Diabetes Malitus", "Enteric Fever", "Fever", "Fibroid Uterus", "Fracture", "Hemorrhoids", "Inguinal Hernia", "Ischemic heart disease", "Lower Respiratory tracT Infection",
    "Malaria", "Mayocardial Infarction", "Osteoarthritis",  "PIVD", "Pneumonitis", "Maternity/Pregnancy/Delivery", "Renal Stone",
    "Road traffic accident", "Seizure disorder", "Tonsilittis", "TRANSIENT ISCHAMIC ATTACK", "Tuberclosis", "Umblical Hernia", "Upper Respiratory tracT infection", "Urinary Tract Infection", "Viral Fever"]
  hospitalNameList: any = [];
  paramountHospitalNameList: any = [];
  noResult: boolean = false;
  registrationNumber: string;
  hospitalCode: any;
  relations: any;
  hospitalStateList:any;
  dateTime = new Date();
  constructor(private router: Router, private serviceURLService: serviceURLService, public commonService: CommonService) { }

  dropdownList = [];
  dropdownListCopy = [];
  selectedItems = [];
  dropdownSettings = {};
  dropdownListCity = [];
  dropdownListCityCopy=[];
  dropdownSettingsCity = {};
  dropdownSettingsHospitalName = {};
  dropdownListHospitalName = [];
  dropdownListHospitalNameCopy=[]
  dropdownListHospitalZone = [];
  StateCode:any;
  cityCode:any;
  careDropDown = false
  hospitalStateRequired = false
  hospitalNameRequired = false
  hospitalCityRequired = false
  validationError=false
  validationMessage:string
  zone:String
  district:String
  careApiFail=false;
  openStateDropdown=false
  openCityDropdown=false
  openHospitalNameDropdown=false
  isInsurerIcici=false
  dateOfBirth:Date
  policyEndDate:Date
  isMobileAvailable=true
  isEmailAvailable=true
  ngOnInit() {
    // console.log("skhjhj")
   
  
    this.dateTime.setDate(this.dateTime.getDate());    
    this.getGroupInsurancePolicyDetails();
    this.adminssionMaxDate = new Date();
   
  }

  onSelectState(item: any) {
    console.log(item);
    this.StateCode = item.item_id,
    this.hospitalState = item.item_text
    this.intimate.hospitalState = item.item_text
    this.openStateDropdown=false
    this.hospitalCityListCare()
  }

  onSelectCity(item: any) {
    console.log(item);
    this.cityCode = item.item_id,
    this.hospitalCity = item.item_text
    this.intimate.hospitalCity = item.item_text
    this.openCityDropdown=false
    this.hospitalNameListCare()
  }

  onSelectHospitalName(item: any) {
    console.log(item);
    this.hospitalCode = item.item_id.id
    this.hospitalName = item.item_text
    this.intimate.hospitalName = item.item_text
    this.hospitalAddress=item.item_id.address
    this.intimate.hospitalAddress=item.item_id.address
    this.hospitalPincode=item.item_id.pincode
    this.intimate.hospitalPincode=item.item_id.pincode
    this.openHospitalNameDropdown=false
  }
  onSelectHospitalZone(item: any) {
    this.zone = item
  }

  onSelectAll(items: any) {
    console.log(items);
  }
  openDropState(){
    this.openStateDropdown=!this.openStateDropdown
    this.openCityDropdown=false
    this.openHospitalNameDropdown=false
  }
  openDropCity(){
    this.openStateDropdown=false
    this.openCityDropdown=!this.openCityDropdown
    this.openHospitalNameDropdown=false
  }
  openDropHospitalName(){
    this.openStateDropdown=false
    this.openCityDropdown=false
    this.openHospitalNameDropdown=!this.openHospitalNameDropdown
    
    console.log("open name")
  }

  handleStateSearch(event){
    console.log(event.target.value)
    let val=event.target.value
    if(val){
      const temp = this.dropdownList.filter(x => {
        console.log(x,"x")
        if (x.name.toLowerCase().indexOf(val) !== -1 || !val) {
          return x;
        }
      });
      
      this.dropdownList = temp;
    }
    else{
      this.dropdownList=this.dropdownListCopy
    }
  }
  handleCitySearch(event){
    console.log(event.target.value)
    let val=event.target.value
    if(val){
      const temp = this.dropdownListCity.filter(x => {
        console.log(x,"x")
        if (x.name.toLowerCase().indexOf(val) !== -1 || !val) {
          return x;
        }
      });
      
      this.dropdownListCity = temp;
    }
    else{
      this.dropdownListCity=this.dropdownListCityCopy
    }
  }

  handleHospitalNameSearch(event){
    console.log(event.target.value)
    let val=event.target.value
    if(val){
      const temp = this.dropdownListHospitalName.filter(x => {
        console.log(x,"x")
        if (x.name.toLowerCase().indexOf(val) !== -1 || !val) {
          return x;
        }
      });
      
      this.dropdownListHospitalName = temp;
    }
    else{
      this.dropdownListHospitalName=this.dropdownListHospitalNameCopy
    }
  }
  
  hospitalStateListCare(){
    this.serviceURLService.getStateListCare().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.hospitalStateList = JSON.parse(successData.data).networkHospitalIO.networkHospitalResponse.data;
      console.log(this.hospitalStateList)
      let data = this.hospitalStateList.map(state=>{
        return({
          ...state,item_id:state.id, item_text:state.name
        })
      })
      this.dropdownList = data.sort((a,b) => (a.item_text > b.item_text) ? 1 : ((b.item_text > a.item_text) ? -1 : 0))
      this.dropdownListCopy=this.dropdownList

      this.dropdownSettings = {
        singleSelection: true,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select State',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 5,
        allowSearchFilter: true,
        closeDropDownOnSelection:true
      };

      this.careApiFail=true
    },err=>{
      this.careApiFail=false;
      this.loading=false
    })
  }

  hospitalCityListCare(){
    this.loading = true
    this.serviceURLService.getCityListCare(this.StateCode).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false
      this.hospitalStateList = JSON.parse(successData.data).networkHospitalIO.networkHospitalResponse.data;
      console.log(this.hospitalStateList)
      let data = this.hospitalStateList.map(state=>{
        return({
          ...state,item_id:state.id, item_text:state.name
        })
      })
      this.dropdownListCity = data.sort((a,b) => (a.item_text > b.item_text) ? 1 : ((b.item_text > a.item_text) ? -1 : 0))
      this.dropdownListCityCopy=this.dropdownListCity
      this.dropdownSettingsCity = {
        singleSelection: true,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select State',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        closeDropDownOnSelection:true
      };
      this.careApiFail=true

    },err=>{
      this.careApiFail=false;
      this.loading=false
    }
      );
  }

  hospitalNameListCare(){
    this.loading = true
    this.serviceURLService.getHospitalNameListCare(this.StateCode, this.cityCode).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false
      this.hospitalStateList = JSON.parse(successData.data).networkHospitalIO.networkHospitalResponse.data;
      console.log(this.hospitalStateList)
      let data = this.hospitalStateList.map(state=>{
        return({
          ...state,item_id:{id:state.hospitalcode,name:state.hospitalname,address:state.location,pincode:state.pincode}, item_text:state.hospitalname
        })
      })
      this.dropdownListHospitalName = data.sort((a,b) => (a.item_text > b.item_text) ? 1 : ((b.item_text > a.item_text) ? -1 : 0))
      this.dropdownListHospitalNameCopy=this.dropdownListHospitalName

      this.dropdownSettingsHospitalName = {
        singleSelection: true,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select State',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true,
        closeDropDownOnSelection:true
      };
      this.careApiFail=true

    },err=>{
      this.careApiFail=false;
      this.loading=false
    })
  }


  getGroupInsurancePolicyDetails() {
    this.loading = true;
    this.noDataFound = false;
    this.serviceURLService.getIntimateGroupPolicyData().pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      successData.response = this.filterOutLatestPolicy(successData.response);
      this.individualInsuranceClaimant = false;
      this.loading = false;

      let insurerList = [];

      this.policiesArrayData = successData.response;
      this.employeeName = localStorage.getItem("name")

      if (this.policiesArrayData.length > 0) {
        this.companyName = this.policiesArrayData[0].companyName?this.policiesArrayData[0].companyName:this.policiesArrayData[0]['Company Name'];
        this.employeeId = this.policiesArrayData[0].empId;
        this.tpaCode = this.policiesArrayData[0].tpaCode;
        console.log(this.tpaCode);
        for (var i = 0; i < this.policiesArrayData.length; i++) {
          if((this.policiesArrayData[i].Product==='Group Health Insurance' ) || (this.policiesArrayData[i].Product===undefined )) {
          this.insurer.push(this.policiesArrayData[i].insurer +' End Date: ' +this.policiesArrayData[i].EndDate);
          this.policyNumber.push(this.policiesArrayData[i].policyNo);
          this.claimantName.push(this.policiesArrayData[i].name);
          this.intimate.email = this.policiesArrayData[i].email;
          this.mobileNumber = this.policiesArrayData[i].mobile;
        
          // this.relationLists.push(this.policiesArrayData[i].Relation);
          // this.tpaCode.push(this.policiesArrayData[i].tpaCode)
          }
          var uniqueInsurerList = Array.from(new Set(this.insurer))
          var uniquePolicyNumberList1 = Array.from(new Set(this.policyNumber))
        }
        console.log(this.claimantName);
      } else {
        $("#noRegisterModal").modal("show");
      }
      this.insurer = uniqueInsurerList;
      this.policyNumber = uniquePolicyNumberList1;
      if(!this.intimate.email) this.isEmailAvailable = false;
      if(!this.mobileNumber) this.isMobileAvailable = false;
    }, errorData => {
      console.log("Oops..!! there is some error in prospect creation");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      }
    })
  }

  getHospitalList() {
    // this.loading = true;
    var insurerName = (this.removeEndDateArr(this.insurer)).toString();
    console.log(insurerName.toString());
    insurerName = insurerName.split(" ")[0];
    var tpa_code = this.tpaCode;
    console.log(tpa_code);
    var insurerOrTpa;
    var pincode = this.intimate.hospitalPincode;
    var policyNumber = this.policyNumber;
    // if(insurerName == 'Religare'){

    switch (insurerName) {
      case "Religare":
        insurerOrTpa = insurerName;
        break;
    }

    switch (tpa_code) {
      case "PMT":
        insurerOrTpa = 'PARAMOUNT'
        break;
    }

    // this.hospitalList.length = 0;
    this.serviceURLService.getHospitals(this.intimate.hospitalName, insurerOrTpa, pincode, policyNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      // this.loading = false;
      // if (successData.success){
      if (insurerOrTpa == "Religare") {
        this.hospitalList = successData.data.data;
        console.log(this.hospitalList);
        if (this.hospitalList.length > 0) {
          for (var i = 0; i < this.hospitalList.length; i++) {
            this.hospitalNameList.push(this.hospitalList[i].hospitalName);
          }
        }
      } else if (insurerOrTpa == "PARAMOUNT") {
        this.paramountHospitalList = JSON.parse(successData.data.data.data.Get_All_HospitalListResult);
        console.log(this.paramountHospitalList);
        if (this.paramountHospitalList.length > 0) {
          for (var i = 0; i < this.paramountHospitalList.length; i++) {
            this.paramountHospitalNameList.push(this.paramountHospitalList[i]['Provider Name']);
          }
        }
      }
      // // }
      // this.hospitalList = successData.data;


    }, errorData => {
      console.log("Oops..!! there is some error");
      this.loading = false;
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      } else if (errorData.error.status === 400) { // temperory solution for registering same number handling 
        this.error = errorData.error.message + "Hospital not found.";
        this.intimateFailure = true;
      }
    });
    // } else {
    //   console.log(this.insurer);
    // }
  }

  selectHospital(hospitalName) {
    var insurerName = (this.removeEndDateArr(this.insurer)).toString();
    insurerName = insurerName.split(" ")[0];
    var insurerOrTpa;
    var pincode = this.intimate.hospitalPincode;
    var policyNumber = this.policyNumber;

    //   switch (insurerName) {
    //     case "Religare" :
    //       insurerOrTpa= insurerName;
    //       break;
    // }

    console.log(this.tpaCode);
    switch (this.tpaCode) {
      case "PMT":
        insurerOrTpa = 'PARAMOUNT'
    }
    // for(var i=0;i<this.hospitalList.length;i++){
    //   if(this.hospitalList[i].hospitalName == hospitalName){
    //     console.log(this.hospitalList);
    //     // this.intimate.hospitalAddress = this.hospitalName[i];
    //     // this.intimate.hospitalPincode = this.hospitalName[i];
    //     // this.tpaCode = this.policiesArrayData[i].tpa_code;
    //     // console.log(this.tpaCode);
    //     // policyNumberList.push(this.policyNumber);
    //     // var uniquePolicyNumberList = Array.from(new Set(policyNumberList))
    //   }
    // }
    this.serviceURLService.getHospitals(this.intimate.hospitalName, insurerOrTpa, pincode, policyNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      if (insurerOrTpa == "Religare") {
        this.hospitalList = successData.data.data;
        console.log(this.hospitalList);
        this.intimate.hospitalAddress = successData.data[0].hospitalAddress;
        this.intimate.hospitalPincode = successData.data[0].pinCode;
      } else if (insurerOrTpa == "PARAMOUNT") {
        this.paramountHospitalList = JSON.parse(successData.data.data.data.Get_All_HospitalListResult);
        console.log(this.paramountHospitalList);
        this.intimate.hospitalAddress = this.paramountHospitalList[0].provider_address;
        this.intimate.hospitalPincode = this.paramountHospitalList[0].PIN_CODE;
        this.hospitalCode = this.paramountHospitalList[0]['Provider Number'];
      }

    });
  }

// Remove End Date Value and return in string
 removeEndDate(data){
    var arr= data.split(' End Date')
    arr=arr[0].toString()
    console.log(arr)
    return arr
    }

// Remove End Date Value and return in array
removeEndDateArr(data){
  var str= data.join()
  str=str.split(' End Date')
  return [str[0]]
  }
  //To get other details according to Insurer
  getInsurerData(selectedIndex) {
    this.relationLists = [];
    let policyNumberList = [];
    

    var insurerName = (this.removeEndDate(this.selectedInsurerName)).toString();

    if(insurerName==="ICICI Lombard General Insurance Company Limited"){
      this.isInsurerIcici=true
    }
    insurerName = insurerName.split(" ")[0];
    console.log('Insurer Name '+insurerName)
    if(insurerName.trim()==="Care"){
      this.hospitalStateListCare();
      this.careDropDown = true;
      this.careApiFail=true;
      this.dropdownListHospitalZone=["North","South","East","West","Central","North East"]
    }
    else{
      this.careDropDown = false;
      this.careDropDown=false;
    }

    if (insurerName == "Religare") {
      this.hospitalListField = true;
      this.paramountHospitalListField = false;
      this.hospitalNameField = false;
    } else
      if (this.tpaCode == "PMT") {
        this.paramountHospitalListField = true;
        this.hospitalListField = false;
        this.hospitalNameField = false;
      } else {
        this.hospitalListField = false;
        this.paramountHospitalListField = false;
        this.hospitalNameField = true;
      }

    for (var i = 0; i < this.policiesArrayData.length; i++) {
      console.log('"'+this.policiesArrayData[selectedIndex-1].insurer+'"'+ '"'+this.removeEndDate(this.selectedInsurerName)+'"')
    
      if (this.removeEndDate(this.insurer[selectedIndex-1]) == this.removeEndDate(this.selectedInsurerName)) {
        console.log('reached')
        this.selectedPolicyNumber = this.policyNumber[selectedIndex-1];
        this.policyEndDate = this.policiesArrayData[i].EndDate;
        // this.tpaCode = this.policiesArrayData[i].tpa_code;
        // console.log(this.tpaCode);
        this.tpaId = this.policiesArrayData[i].TPA_ID;
        this.tpaName = this.policiesArrayData[i].TPA_NAME;
        // policyNumberList.push(this.policyNumber);
        // var uniquePolicyNumberList = Array.from(new Set(policyNumberList))
      }
    }

    // this.policyNumber = policyNumberList;
    // this.policyNumber = uniquePolicyNumberList;
    //this.selectedClaimantName = this.claimantName[0];
    // this.selectedPolicyNumber = this.policyNumber[0];

    var policyNumberInput = <HTMLInputElement>document.getElementById("policyNumber");
    policyNumberInput.disabled = true;
    this.getPolicyNumberData();
  }

  //To get Claimant according to Policy number
  getPolicyNumberData() {
    let claimantNameList = [];

    for (var i = 0; i < this.policiesArrayData.length; i++) {
      if (this.policiesArrayData[i].policyNo == this.selectedPolicyNumber) {
        this.claimantName = this.policiesArrayData[i];


        claimantNameList.push(this.claimantName);

      }
    }

    this.claimantName = claimantNameList;
    this.selectedClaimantName = this.claimantName[0];
    this.sendClaimantName = this.claimantName[0].name;
    this.productType = this.claimantName[0].Product;
    console.log(claimantNameList, "data")
    console.log(this.claimantName[0].Product, "Productdata")

    var claimantNameInput = <HTMLInputElement>document.getElementById("claimant");
    claimantNameInput.disabled = false;
    this.getCardNumberData(this.claimantName[0]);
  }

  //To get Card no. according to claimant
  getCardNumberData(selectedMember) {
        this.cardNumber = selectedMember.cardNo;
        this.selectedRelation = selectedMember.Relation
        this.sendClaimantName = selectedMember.name;
       // this.productType = selectedMember.Poduct;
        //console.log(selectedMember)
        
  }

  // uncomment this function for individual insurance case

  // getIndividualInsurancePolicyDetails() {
  //   this.loading = true;
  //   this.contactNo = localStorage.getItem("mobileNumber")
  //   this.serviceURLService.getIntimateIndividualPolicyData(this.contactNo).subscribe((successData:any) => {

  //     this.individualInsuranceClaimant = true;
  //     this.loading = false;

  //     if(successData.error == "No data found"){
  //       this.noDataFound =true;
  //     }else{
  //       let claimantNameList=[];
  //       let policyNumberList = [];
  //       let insurerList = [];
  //       let policiesArrayData = successData.data; 

  //       this.claimantName = policiesArrayData[0].claiment;
  //       for(var i=0; i< policiesArrayData.length; i++){
  //         this.email = policiesArrayData[0].email;
  //         this.mobile = policiesArrayData[0].mobile;
  //         this.policyNumber = policiesArrayData[i].policy;
  //         this.insurer = policiesArrayData[i].insurer;

  //         policyNumberList.push(this.policyNumber);
  //         insurerList.push(this.insurer)

  //       }
  //       this.policyNumber = policyNumberList;
  //       this.insurer = insurerList;
  //     }
  //   }, errorData => {
  //     console.log("Oops..!! there is some error in prospect creation");
  //     if(errorData.error.status === 403){
  //       this.error = errorData.error.message;
  //     }
  //   })
  // }

  submitIntimateDetails() {
    console.log("hghg", this.intimate.hospitalState)

    if(this.removeEndDate(this.selectedInsurerName)=='' || this.removeEndDate(this.selectedInsurerName)==undefined){
      this.validationError = true
      this.validationMessage = 'Insurer Name is Required'
      return
    }
    else if(this.selectedPolicyNumber=='' || this.selectedPolicyNumber==undefined ){
      this.validationError = true
      this.validationMessage = 'Policy Number is Required'
      return
    }
    else if(this.isInsurerIcici && !this.dateOfBirth ){
      this.validationError = true
      this.validationMessage = 'Date of bitrh is Required'
      return
    }
    else if(this.sendClaimantName=='' || this.sendClaimantName==undefined ){
      this.validationError = true
      this.validationMessage = 'Patient Name is Required'
      return
    }
    else if(this.intimate.ailment=='' || this.intimate.ailment==undefined ){
      this.validationError = true
      this.validationMessage = 'Disease Name is Required'
      return
    }
    else if(this.regDate=='' || this.regDate==undefined ){
      this.validationError = true
      this.validationMessage = 'Admission Date is Required'
      return
    }

    else if(this.intimate.estimatedAmount=='' || this.intimate.estimatedAmount==undefined ){
      this.validationError = true
      this.validationMessage = 'Estimated Amount is Required'
      return
    }

    else if(this.intimate.hospitalState=='' || this.intimate.hospitalState==undefined){
      this.validationError = true
      this.validationMessage = 'Hospital State is Required'
      return
    }
    else if(this.intimate.hospitalCity=='' || this.intimate.hospitalCity==undefined){
      this.validationError = true
      this.validationMessage = 'Hospital City is Required'
      return
    }
    else if(this.intimate.hospitalName=='' || this.intimate.hospitalName==undefined ){
      this.validationError = true
      this.validationMessage = 'Hospital Name is Required'
      return
    }
    else if((this.careDropDown|| this.isInsurerIcici) && (this.intimate.hospitalAddress=='' || this.intimate.hospitalAddress==undefined )){
      this.validationError = true
      this.validationMessage = 'Hospital Address is Required'
      return
    }
    else if((this.careDropDown|| this.isInsurerIcici) && (this.intimate.hospitalPincode=='' || this.intimate.hospitalPincode==undefined )){
      this.validationError = true
      this.validationMessage = 'Hospital Pincode is Required'
      return
    }
    else if(this.careDropDown&& (this.district=='' || this.district==undefined )){
      this.validationError = true
      this.validationMessage = 'Hospital District is Required'
      return
    }
    else if(this.careDropDown&& (this.zone=='' || this.zone==undefined )){
      this.validationError = true
      this.validationMessage = 'Hospital zone is Required'
      return
    }
    else if(this.dischargeDate=='' || this.dischargeDate==undefined ){
      this.validationError = true
      this.validationMessage = 'Discharge Date is Required'
      return
    }else if(new Date(this.policyEndDate).getTime() < new Date(this.dischargeDate).getTime() ||
      new Date(this.dischargeDate).getTime() < new Date(this.regDate).getTime()){
      this.validationError = true
      this.validationMessage = 'Admission date or Discharge date should be less than policy end date.'
      return
    }else if (this.intimate.email == '' || this.intimate.email == undefined || !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$/.test(this.intimate.email)) {
      this.validationError = true
      this.validationMessage = 'Valid email is required'
      return
    }else if(this.mobileNumber == '' || this.mobileNumber == undefined || !/^\d{10}$/.test(this.mobileNumber)) {
      this.validationError = true
      this.validationMessage = 'Valid mobile number is required'
      return
    }

   else{
    this.validationError = false
   



    if (this.regDate) {
      var newAdmissionDateTime = new Date(this.regDate);
      newAdmissionDateTime.setHours(this.regDate.getHours() + 5);
      newAdmissionDateTime.setMinutes(this.regDate.getMinutes() + 30);
    }
    if (this.dischargeDate) {
      var newDischargeDateTime = new Date(this.dischargeDate);
      newDischargeDateTime.setHours(this.dischargeDate.getHours() + 5);
      newDischargeDateTime.setMinutes(this.dischargeDate.getMinutes() + 30);
    }
    if ((this.companyName == "") || this.companyName ===undefined) {
      this.companyName = "-"
    }

    this.loading = true;
    this.intimate = {
      "mobileNo": (this.mobileNumber),
      "corporateName": (this.companyName),
      "employeeName": (this.employeeName),
      "employeeId": this.employeeId,
      "insurer": (this.removeEndDate(this.selectedInsurerName)),
      "policyNumber": (this.selectedPolicyNumber),
      "claimant": (this.sendClaimantName),
      "relationWithEmployee": (this.selectedRelation),
      "cardNumber": (this.cardNumber),
      "email": this.intimate.email,
      "productType": "Group Health Insurance",
      "productId": 1,
      "hospitalState": this.intimate.hospitalState,
      "hospitalCity": this.intimate.hospitalCity,
      "hospitalName": this.intimate.hospitalName,
      "hospitalAddress": this.intimate.hospitalAddress,
      "hospitalPincode": this.intimate.hospitalPincode,
      "hospitalCode": this.hospitalCode,
      "estimatedAmount": this.intimate.estimatedAmount,
      "claimedAmount": this.intimate.estimatedAmount,
      "claimMode": "REIMBURSEMENT",
      "claimSource": "notify",
      "rm": "",
      "ailment": this.intimate.ailment,
      "admissionDate": this.removeTime(newAdmissionDateTime),
      "dischargeDate": this.removeTime(newDischargeDateTime),
      "status": "INTIMATED",
      "subStatus": "INTIMATED",
      "registerManually": false,
      "emergencyContactName": this.sendClaimantName,
      "phm": this.intimate.phm,
      "tpaId": this.tpaId ,
      "tpaName": this.tpaName ,
      "babyName":this.babyName,
      "babyDob":this.removeTime(this.babyDob),
      "babyGender":this.babyGender,
      "employeeCode":this.employeeCode,
      "registrationRemarks": "",
      "recordEnteredBy":"",
      "zone":this.zone,
      "district":this.district,
      "policyType": "Group"
      
    }
    if(this.isInsurerIcici){
      this.intimate["dateOfBirth"]=this.removeTime(this.dateOfBirth)
    }
    this.serviceURLService.submitClaimIntimate(this.intimate).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {

      this.loading = false;

      this.errorMessage = successData.error;
      if (!successData.response.pamResponse.success) {

        this.intimateFailure = true;
      } else {
        this.intimateSuccessfull = true;
        this.registrationNumber = successData.response.pamResponse.data;
      }
    }, errorData => {
      console.log("Oops..!! there is some error");
      this.loading = false;
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
      } else if (errorData.error.status === 400) { // temperory solution for registering same number handling 
        this.error = errorData.error.message + " Number is already registered.";
        this.intimateFailure = true;
      } else if (errorData.error.status === 500) { // temperory solution for registering same number handling 
        this.errorMessage = errorData.error.message;
        console.log(errorData);
        this.intimateFailure = true;
      }
    })
  }

  }

  removeTime(a){
    const startDate =new Date(a);
    let startMonth = startDate.getMonth()<=8?'0'+(Number(startDate.getMonth())+Number(1)):Number(startDate.getMonth())+Number(1)
    let date = startDate.getDate()<=9?'0'+Number(startDate.getDate()):Number(startDate.getDate())
    console.log(startDate.getFullYear()+'-'+startMonth+'-'+date)
    return startDate.getFullYear()+'-'+startMonth+'-'+date;
  }
  checkAdmissionDatevalue() {
    if (this.regDate) {
      this.AddmissionDateRequired = false;
    } else {
      this.AddmissionDateRequired = true;
    }
  }

  checkDischargeDatevalue() {
    if (this.dischargeDate) {
      this.dischargeDateRequired = false;
    } else {
      this.dischargeDateRequired = true;
    }
  }

  selectTreatment(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }

  checkTreatmentValue(event): void {
    this.noResult = this.commonService.checkCityValue(event, this.diseaseList);
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

  filterOutLatestPolicy(data){
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    let filteredData = data.filter(item => new Date(item.EndDate) > oneYearAgo);
    return filteredData
  }
}